// Dependency
import React from 'react';

// Components
import NavigationLists from '../navigation-lists/navigation-lists';

// Internationalization
import { useTranslation } from 'react-i18next';

// Styles
import * as productStyles from '../../templates/product/product.module.scss';
import * as footerStyles from './footer.module.scss';

// Template
const FooterTabs = (props) => {

  // Translation Function
  const { t } = useTranslation();

  const toggleTab = (tabTop, tabBottom) => {
    //Transform animation
    tabBottom.offsetParent === null ? tabTop.classList.add(productStyles.cdProductTabsOpened) : tabTop.classList.remove(productStyles.cdProductTabsOpened);
    //Toggle visibillity
    tabBottom.style = tabBottom.offsetParent === null ? 'display: block; max-height: 1700px;' : 'display: none; max-height: 0;';
  }

  return (
   
      <section className={footerStyles.footerTabs}>
            <>
              <div className={`${productStyles.cdSingleProductTabs} ${footerStyles.cdFooterTabs}`} >
                <div className={`${productStyles.cdSingleProductTabTop} ${footerStyles.cdFooterTabTop}`} onClick={(e) => {
                  toggleTab(e.currentTarget, e.currentTarget.nextElementSibling)
                }}>
                  <span>Flowlife</span>
                  <i className="material-icons">add</i>
                </div>
                <div className={`${productStyles.cdProductTabContent} ${footerStyles.cdFooterTabContent}`}>
                  <NavigationLists data={props.flowLinks} />
                </div>
              </div>
              <div className={`${productStyles.cdSingleProductTabs} ${footerStyles.cdFooterTabs}`} >
                <div className={`${productStyles.cdSingleProductTabTop} ${footerStyles.cdFooterTabTop}`} onClick={(e) => {
                  toggleTab(e.currentTarget, e.currentTarget.nextElementSibling)
                }}>
                  <span>{t('footer.follow')}</span>
                  <i className="material-icons">add</i>
                </div>
                <div className={`${productStyles.cdProductTabContent} ${footerStyles.cdFooterTabContent}`}>
                  <NavigationLists data={props.socialMedia} />
                </div>
              </div>
              <div className={`${productStyles.cdSingleProductTabs} ${footerStyles.cdFooterTabs}`} >
                <div className={`${productStyles.cdSingleProductTabTop} ${footerStyles.cdFooterTabTop}`} onClick={(e) => {
                  toggleTab(e.currentTarget, e.currentTarget.nextElementSibling)
                }}>
                  <span>{t('footer.service')}</span>
                  <i className="material-icons">add</i>
                </div>
                <div className={`${productStyles.cdProductTabContent} ${footerStyles.cdFooterTabContent}`}>
                  <NavigationLists data={props.helpMenu} />
                </div>
              </div>
              <div className={`${productStyles.cdSingleProductTabs} ${footerStyles.cdFooterTabs}`} >
                <div className={`${productStyles.cdSingleProductTabTop} ${footerStyles.cdFooterTabTop}`} onClick={(e) => {
                  toggleTab(e.currentTarget, e.currentTarget.nextElementSibling)
                }}>
                  <span>{t('footer.info')}</span>
                  <i className="material-icons">add</i>
                </div>
                <div className={`${productStyles.cdProductTabContent} ${footerStyles.cdFooterTabContent}`}>
                  <NavigationLists data={props.infoMenu} />
                </div>
              </div>
            </>
            </section>
  )
};

export default FooterTabs;